import { render, staticRenderFns } from "./CurrentTime.vue?vue&type=template&id=2a6e2df5&scoped=true"
import script from "./CurrentTime.vue?vue&type=script&lang=js"
export * from "./CurrentTime.vue?vue&type=script&lang=js"
import style0 from "./CurrentTime.vue?vue&type=style&index=0&id=2a6e2df5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e2df5",
  null
  
)

export default component.exports